/**
 * @description 保單保障內容類型 (enum)
 */
export enum PolicyCoverageTypesEnum {
  /** 主約 */
  M = 'M',
  /** 附加 */
  S = 'S'
}
